import { useI18n } from '#/i18n/hooks/useI18n';
import { I18nLocale } from '#/i18n/types/I18nLocale';
import { searchGetVolopsRoutePath } from '#/modules/search/volops/routing/searchGetVolopsRoutePath';
import { trackClicked } from '#/utils/analytics/track/trackClicked';

import { PageHeaderButtonOrLink } from './PageHeader.styled';

export function VolunteerLink() {
  const { i18n, locale } = useI18n();
  return (
    <PageHeaderButtonOrLink
      qaId="nav-volop-link"
      href={searchGetVolopsRoutePath({ locale, embedSearchWidgetId: null })}
      onClick={() => trackClicked('Volunteer', { context: 'Header' })}
      type="link"
    >
      {locale === I18nLocale.PT ? 'Voluntariar' : i18n('Volunteer')}
    </PageHeaderButtonOrLink>
  );
}
